var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeartLiked = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19px",
  height: "18px",
  viewBox: "0 0 19 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Feed",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Feed-",
  transform: "translate(-14.000000, -497.000000)",
  fill: "#6467EF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 96.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Post-01"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(14.000000, 396.048053)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_Icons-/-8-Like",
  transform: "translate(0.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "heart",
  transform: "translate(0.000000, 1.428571)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.0952381,0 C16.6056132,0 18.8571429,2.46717936 18.8571429,6.42857143 C18.8571429,9.52923482 15.7893168,13.0359077 9.71313158,17.0569126 C9.53996927,17.1715053 9.31717359,17.1715053 9.14401128,17.0569126 C3.06782609,13.0359077 0,9.52923482 0,6.42857143 C0,2.46717936 2.2515296,0 5.76190476,0 C7.36235437,0 8.60061756,0.560800232 9.42857143,1.66685649 C10.2565253,0.560800232 11.4947885,0 13.0952381,0 Z",
  id: "Shape"
}))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartLiked);
export default ForwardRef;